import React, {useState} from 'react';
import {Scrollbars} from 'react-custom-scrollbars';
import styled from 'styled-components';
import ReactSelect from '../../components/react-select';
import RoundButton from '../../components/roundButton';
import moment from 'moment';
import {Link} from 'react-router-dom';
import I18nMessage from '../../components/I18nMessage';
import beep from "./voice_on.mp3";
import useSound from "use-sound";

const EventContent = styled.div`
  margin-top: -23px;
  // margin-bottom: -16px !important;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 350px;
`;

const EventFilter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background-color: white;
  box-shadow: 0 0.125rem 0.3rem rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  > div {
    display: flex;
    align-items: center;
  }
  > h4 {
    color: ${(props) => props.theme};
    text-align: center;
    font-weight: bold;
  }
`;

const ReactSelectStyled = styled(ReactSelect)`
  .select {
    border-radius: 9px !important;
  }
`;

const ButtonsStyle = styled.div`
  button {
    height: 2.7rem;
    width: 2.7rem;
  }
`;

const colors = {
    green: '#00b105',
    red: '#f2392d',
};

const Card = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    border: ${(props) => `1px solid ${colors.red}`};
    box-shadow: 0 0.125rem 0.3rem rgba(0, 0, 0, 0.4);
  `;

const Description = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: auto;
    text-align: left;
    span {
      color: ${colors.red};
      font-weight: bold;
      font-size: 0.8rem;
    }
    small {
    }
  `;

const Span = styled.span`
    color: ${colors.red};
    font-size: 1.5rem;
  `;

const Date = styled.span`
    color: ${colors.red};
    font-weight: 600;
    font-size: 0.8rem;
  `;

const LinkStyled = styled(Link)`
    color: inherit !important;
    text-decoration: inherit !important;
  `;

const getEventI18N = (type, attributes) => {
    return attributes.alarm ?
        `alarm${String(attributes.alarm)
            .charAt(0)
            .toUpperCase()}${String(attributes.alarm).slice(1)}` :
        `event${String(type)
            .charAt(0)
            .toUpperCase()}${String(type).slice(1)}`;
};

const EventCard = ({
                       id,
                       deviceId,
                       type,
                       serverTime,
                       name,
                       attributes,
                       ...props
                   }) => {

    return (
        <LinkStyled to={`/admin/events/${id}`}>
            <Card {...props} className="mb-2 p-3">
                <Description>
                    <span>{name}</span>
                    <small>
                        <I18nMessage id={getEventI18N(type, attributes)}/>
                    </small>
                </Description>
                <Date className="mr-1 ml-1">{moment(serverTime).fromNow()}</Date>
                <Span className="fas fa-map-marker-alt ml-2"/>
            </Card>
        </LinkStyled>
    );
};

const EventList = (props) => {

    const [play] = useSound(beep);
    const [filters, setFilters] = useState([]);
    const [eventSize, setEventSize] = useState(props.events.length);
    const hasFilter = filters.length;
    const setFilter = (filters) => setFilters(filters ? filters.map(({id}) => id) : []);
    const eventsList = props.events.filter(({type}) => (!hasFilter ? true : filters.includes(type)))
                                   .map((e, i) => <EventCard key={e.id} {...e} />);

    if (props.events.length > eventSize){
        if( props.isSoundEnabled ) {
            play();
        }
        setEventSize(props.events.length);
    }

    return (
        <EventContent id="eventList" className="pr-3">
            <div className="" style={{marginTop: '8px', zIndex: 10}}>
                <EventFilter theme={props.theme}>
                    <h4 className="mt-2">Filtrar Eventos</h4>
                    <ButtonsStyle>
                        <ReactSelectStyled
                            options={props.eventTypes}
                            name="typeDevice"
                            scoped={false}
                            noOptionsMessage={() => 'Nenhum resultado encontrado!'}
                            placeholder="Tipo"
                            className="w-100"
                            menuPlacement="bottom"
                            multiple={true}
                            onChange={setFilter}
                        />
                        <RoundButton className="mx-2"
                                     onClick={props.enableDisableSound}
                                     active={props.isSoundEnabled}>
                            <span className="fal fa-bell"/>
                        </RoundButton>
                        <RoundButton onClick={props.removeAll}>
                            <span className="fal fa-trash-alt"/>
                        </RoundButton>
                    </ButtonsStyle>
                </EventFilter>
            </div>
            <Scrollbars style={{height: '100%'}} hideTracksWhenNotNeeded={true}>
                <div className="p-3 py-2">{eventsList}</div>
            </Scrollbars>
        </EventContent>
    );
}

export default EventList;
